import { colors, weights } from '@components/theme/styles/index';
import { AvatarGroup, Box, Menu, styled } from '@mui/material';
import { Avatar } from '@nx-fe/components';
import { rem } from 'polished';

export const StyledWatchers = styled('div')(
  ({ theme }) =>
    ({
      display: 'flex',
      alignItems: 'center',

      [theme.breakpoints.down('md')]: {
        paddingLeft: 0,
      },
    }) as any,
);

export const WatchersLabel = styled('span')({
  fontSize: rem(14),
  fontWeight: weights.medium,
  color: colors.grayDark2,
  marginRight: rem(20),
});

export const WatchersField = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: rem(8),
});

export const WatchersAvatarGroup = styled(AvatarGroup)({
  alignItems: 'center',

  '& .surplus': {
    backgroundColor: colors.grayLight2,
    color: colors.grayDark2,
    border: `1px solid ${colors.grayDark2} !important`,
    width: rem(34),
    height: rem(34),
    fontSize: rem(16),
  },
});

export const WatchersAvatar = styled(Avatar)({
  border: `1px solid ${colors.grayDark2} !important`,
  backgroundColor: colors.white,
});

export const WatchersMenu = styled(Menu)({
  '& .MuiMenu-paper': {
    border: `1px solid ${colors.gray}`,
    padding: rem(4),
    marginTop: rem(8),
    minWidth: rem(320),
  },
});

export const WatchersMenuHeading = styled('div')({
  padding: `${rem(8)} ${rem(12)}`,
  fontWeight: weights.medium,
  color: colors.grayDark3,
});

export const WatchersMenuItem = styled('li')({
  display: 'flex',
  alignItems: 'center',
  padding: rem(6),
  fontSize: rem(14),
  gap: rem(8),
  cursor: 'pointer',
  flex: 1,
  '&:hover': {
    backgroundColor: colors.secondaryLight4,
    color: colors.secondaryDark2,
  },
});

export const WatchersMenuAction = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: rem(8),
  '& svg': {
    color: colors.secondaryLight3,
  },
});

export const WatchersMenuItemButton = styled('div')({
  padding: rem(6),
  fontSize: rem(14),
  gap: rem(8),
  cursor: 'unset',
  '&:hover': {
    backgroundColor: colors.grayLight2,
  },
});

export const TeamsIcon = styled('span')({
  color: colors.grayDark3,
  paddingLeft: rem(4),
  paddingRight: rem(6),
});

export const StyledBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  justifyContent: 'space-between',
  width: '100%',
});
